<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(onSubmit)" novalidate >
      <b-row class="mt-3 justify-content-center">
        <b-col md="8">
          <b-card header-tag="header" footer-tag="footer">
            <template #header>
              <h6 class="mb-0">Formulário de Candidatura</h6>
            </template>
            <b-card-text>
              <b-progress
                class="mb-2"
                :value="step - 1"
                :max="maxSteps"
              ></b-progress>

              <b-form-group label="Dados Gerais" v-if="step == 1">
                <main-form v-model="candidate"></main-form>
              </b-form-group>

              <b-form-group label="Dados dos pais" v-if="step == 2">
                <parents-form v-model="candidate"></parents-form>
              </b-form-group>
              <b-form-group label="Dados dos filhos" v-if="step == 3">
                <children-form v-model="candidate"></children-form>
              </b-form-group>
              <b-form-group label="Dados de Candidaturas" v-if="step == 4">
                <camtil-form v-model="candidate"></camtil-form>
              </b-form-group>
              <div v-if="step == 5" >
                <h2>Reveja a sua candidatura</h2>
                <h4>Família</h4>
                <dl class="row">
                  <dt class="col-sm-3 text-md-right">Apelido</dt>
                  <dd class="col-sm-9">{{ candidate.surname }}</dd>
                  <dt class="col-sm-3 text-md-right">Email</dt>
                  <dd class="col-sm-9">{{ candidate.email }}</dd>
                  <dt class="col-sm-3 text-md-right">Telefone</dt>
                  <dd class="col-sm-9">{{ candidate.phone }}</dd>
                  <dt class="col-sm-3 text-md-right">Morada</dt>
                  <dd class="col-sm-9">{{ candidate.address }}</dd>
                  <dt class="col-sm-3 text-md-right">Código Postal</dt>
                  <dd class="col-sm-9">{{ candidate.zip_code }}</dd>
                  <dt class="col-sm-3 text-md-right">Localidade</dt>
                  <dd class="col-sm-9">{{ candidate.locality }}</dd>
                </dl>
                <h4>Dados dos pais</h4>
                <dl class="row">
                  <dt class="col-sm-3 text-md-right">Nome do pai</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.father.name }}</dd>
                  <dt class="col-sm-3 text-md-right">Email do pai</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.father.email }}</dd>
                  <dt class="col-sm-3 text-md-right">Telefone do pai</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.father.phone }}</dd>
                  <dt class="col-sm-3 text-md-right">Nome da mãe</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.mother.name }}</dd>
                  <dt class="col-sm-3 text-md-right">Email da mãe</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.mother.email }}</dd>
                  <dt class="col-sm-3 text-md-right">Telefone da mãe</dt>
                  <dd class="col-sm-9">{{ candidate.parents_data.mother.phone }}</dd>
                </dl>
                <h4>Dados dos filhos</h4>
                <dl class="row" v-for="(kid,index) in candidate.kids_data" :key="index">
                  <dt class="col-sm-3 text-md-right">Nome</dt>
                  <dd class="col-sm-9">{{ kid.name }}</dd>
                  <dt class="col-sm-3 text-md-right">Data de nascimento</dt>
                  <dd class="col-sm-9">{{ kid.birthdate }}</dd>
                </dl>
                <h4>Candidaturas ao Camtil</h4>
                <dl class="row">
                  <dt class="col-sm-3 text-md-right">Nº de candidaturas anteriores</dt>
                  <dd class="col-sm-9">{{ candidate.previous_tries }}</dd>
                </dl>
               
              </div>
              <div v-if="step == 6">
                <p v-if="submitting">A sua candidatura está a ser submetida</p>
                <p v-if="submitted">A sua candidatura foi submetida e ficou registada com o código <strong>{{ submissionId }}</strong></p>
              </div>
            </b-card-text>

            <template #footer>
              <b-btn type="button" v-if="step > 1 && !(submitting || submitted)" @click="goBack()"
                >Anterior</b-btn
              >
              <b-btn type="submit"  v-if="!(submitting || submitted)"  class="float-right" variant="primary"
                >{{ btnText }}</b-btn
              >
            </template>
          </b-card>
          <pre>
            {{ candidate }}
          </pre>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import MainForm from "./parts/main.vue";
import ParentsForm from "./parts/parents.vue";
import CamtilForm from "./parts/camtil.vue";
import ChildrenForm from "./parts/children.vue";
export default {
  name: "CandidatesForm",
  mixins: [],
  components: { MainForm, ParentsForm, CamtilForm, ChildrenForm },
  data() {
    return {
      step: 1,
      maxSteps: 5,
      submitting: false,
      submitted: false,
      submissionId: '',
      btnText: 'Seguinte',
      candidate: {
        surname: "",
        email: "",
        phone: "",
        address: "",
        locality: "",
        zip_code: "",
        country_id: "",
        previous_tries_check: 0,
        previous_tries: 0,
        parents_participated: 0,
        parents_part_detail: '',
        parents_data: {
            father: {
                name: null,
                email: null,
                phone: null,
            },
            mother: {
                name: null,
                email: null,
                phone: null,
            }
        },
        n_kids: 1,
        kids_data: [{
          name: '',
          birthdate: null
        }],
        tac_accepted: 0,
      },
    };
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.candidate = {
        name: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    goBack() {
      let back = this.step - 1;
      this.step = Math.max(0, back);
    },
    onSubmit() {
      if (this.step < this.maxSteps) {
        this.step++;
        if(this.step == this.maxSteps ) {
          this.btnText = 'Enviar'
        } else {
          this.btnText = 'Seguinte'
        }
      } else if (this.step == this.maxSteps) {
        this.step++;
        let data = { data: this.candidate }
        this.submitting = true
        this.axios.post('candidates', data).then(response => {
          this.submitting = false
          this.submitted = true
          this.submissionId = response.data.data.uuid
          console.log(response.data)
        })
      }
    },
  },
};
</script>

<style>
</style>
